<div class="page">
  <img [src]="bannerSrc" class="home-banner" *ngIf="bannerSrc" />
  <div *ngIf="dataService.user && dataService.user.email" style="margin-bottom: 2em">
    <div style="display: flex; align-items: baseline">
      <h2>My Projects</h2>
      <app-auth-check allow="super-admin" style="margin-left: auto">
        <button mat-button (click)="addProject()"><mat-icon>add</mat-icon>New Project</button>
      </app-auth-check>
    </div>
    <div *ngIf="(dataService.userProjects$ | async).length===0">
      <p *ngIf="dataService.userProjectsLoading">Loading User Projects...</p>
      <p *ngIf="!dataService.userProjectsLoading">You are not a member of any projects</p>
    </div>
    <div class="project-card-container">
      <app-project-card
        *ngFor="let project of (dataService.userProjects$ | async)"
        [project]="project"
        (click)="goToProject(project)"
      ></app-project-card>
    </div>
  </div>
  <div>
    <div *ngIf="(dataService.publicProjects$ | async) as publicProjects">
      <div *ngIf="publicProjects.length>0">
        <h2>Public Projects</h2>
        <app-project-filter
          [projects]="publicProjects"
          (projectsFiltered)="filteredPublicProjects=$event"
        ></app-project-filter>

        <div class="project-card-container">
          <app-project-card
            *ngFor="let project of filteredPublicProjects"
            [project]="project"
            (click)="goToProject(project)"
          ></app-project-card>
        </div>
      </div>
    </div>
  </div>
</div>
